var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalyticsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.166 3.25H9.91602V1C9.91602 0.59 9.57602 0.25 9.16602 0.25C8.75602 0.25 8.41602 0.59 8.41602 1V3.25H2.16602C1.20602 3.25 0.416016 4.04 0.416016 5V13C0.416016 13.96 1.20602 14.75 2.16602 14.75H5.84602L3.52602 18.61C3.31602 18.96 3.42602 19.43 3.78602 19.64C3.90602 19.71 4.03602 19.75 4.17602 19.75C4.42602 19.75 4.67602 19.62 4.81602 19.39L7.59602 14.75H8.42602V18C8.42602 18.41 8.76602 18.75 9.17602 18.75C9.58602 18.75 9.92602 18.41 9.92602 18V14.75H10.756L13.536 19.39C13.676 19.62 13.926 19.75 14.176 19.75C14.306 19.75 14.436 19.72 14.556 19.64C14.916 19.43 15.026 18.97 14.816 18.61L12.496 14.75H16.166C17.126 14.75 17.916 13.96 17.916 13V5C17.916 4.04 17.126 3.25 16.166 3.25ZM16.416 13C16.416 13.14 16.306 13.25 16.166 13.25H2.16602C2.02602 13.25 1.91602 13.14 1.91602 13V5C1.91602 4.86 2.02602 4.75 2.16602 4.75H16.166C16.306 4.75 16.416 4.86 16.416 5V13Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16602 8.25C5.75602 8.25 5.41602 8.59 5.41602 9V11C5.41602 11.41 5.75602 11.75 6.16602 11.75C6.57602 11.75 6.91602 11.41 6.91602 11V9C6.91602 8.59 6.57602 8.25 6.16602 8.25Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16602 7.25C8.75602 7.25 8.41602 7.59 8.41602 8V11C8.41602 11.41 8.75602 11.75 9.16602 11.75C9.57602 11.75 9.91602 11.41 9.91602 11V8C9.91602 7.59 9.57602 7.25 9.16602 7.25Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.166 6.25C11.756 6.25 11.416 6.59 11.416 7V11C11.416 11.41 11.756 11.75 12.166 11.75C12.576 11.75 12.916 11.41 12.916 11V7C12.916 6.59 12.576 6.25 12.166 6.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsIcon);
export default __webpack_public_path__ + "static/media/analytics-icon.c5a76af127b9466a8f79e7dec6713d98.svg";
export { ForwardRef as ReactComponent };